import { AppConfig } from 'AppConfig';

const {
  domain,
  apiPath,
  createTokenPath,
} = AppConfig.authApi.hca;

// API paths
const API_URL = `${domain}/${apiPath}`;
const CREATE_TOKEN_URL = `${API_URL}/${createTokenPath}`;

export {
  CREATE_TOKEN_URL,
};
